import { useNavigate, useSearchParams } from "react-router-dom";
import {
  InvoicesListPage as InvoicesListPageView,
  type InvoicesListFilters,
} from "@/components/InvoicesListPage";

export function InvoicesListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const states = searchParams.getAll("states");
  const defaultFilters: InvoicesListFilters = {
    states: states.length > 0 ? (states as InvoicesListFilters["states"]) : undefined,
    dateFrom: searchParams.get("dateFrom") ?? undefined,
    dateTo: searchParams.get("dateTo") ?? undefined,
  };

  function handleFiltersChange(filters: InvoicesListFilters) {
    const next = new URLSearchParams();
    filters.states?.forEach((s) => next.append("states", s));
    if (filters.dateFrom) next.set("dateFrom", filters.dateFrom);
    if (filters.dateTo) next.set("dateTo", filters.dateTo);
    setSearchParams(next, { replace: true });
  }

  return (
    <InvoicesListPageView
      onInvoiceClick={(id) => navigate(`/invoices/${id}`)}
      onCreateInvoice={() => navigate("/invoices/new")}
      onSendInvoice={(id) => navigate(`/invoices/${id}?send=1`)}
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
